import { useState } from 'react';
import './assets/scss/styles.scss'
import Authentication from "./components/Authentication";
import AppLayout from './components/Layout/AppLayout';
import AuthState from './components/Context/AuthContext';
import { ConfigProvider } from 'antd';


function App() {
    return (
        <AuthState>
            <div className="App">


                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: '#a52c22',
                        },
                    }}

                >
                    <AppLayout />
                </ConfigProvider>
            </div>
        </AuthState>
    );
}

export default App;
